import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";
import {ResourceService} from "./resource.service";

@Injectable()

export class SurveyService extends ResourceService {
  constructor(private authorizedService: AuthorizedService) {
    super(authorizedService, ServiceConfig.survey.listUrl, ServiceConfig.survey.detailUrl);
  }

  answer(id, formData) {
    return this.authorizedService.post(ServiceConfig.survey.answer.replace("{id}", id), formData).map(data => {
      return data;
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/survey.service.ts